import { FoodItem } from "src/app/services/merchant/food.service.base";

export type FoodItemAvailability = Pick<
  FoodItem,
  "name" | "id" | "profileImageUrl"
> & {
  isAvailable: boolean;
  unavailableUtilTo?: Date;
};

export enum OrderStatuses {
  CREATED = "CREATED",
  READY_FOR_ACCEPT = "READY_FOR_ACCEPT",
  ACCEPTED = "ACCEPTED",
  CONFIRMED = "CONFIRMED",
  PREPARING = "PREPARING",
  COMPLETED = "COMPLETED",
  ORDER_TIMED_OUT = "ORDER_TIMED_OUT",
  READY_FOR_PICKUP = "READY_FOR_PICKUP",
  ADJUSTMENT_REQUEST_PENDING = "ADJUSTMENT_REQUEST_PENDING",
  ON_THE_ROAD = "DELIVERING",
  OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
  DELIVERED = "DELIVERED",
  CANCELLED_BY_CUSTOMER = "CANCELLED_BY_CUSTOMER",
  CANCELLED_BY_RESTAURANT = "CANCELLED_BY_RESTAURANT",
  REJECTED_BY_RESTAURANT = "REJECTED_BY_RESTAURANT",
  REFUNDED = "REFUNDED",
  CANCELLED = "CANCELLED",
}

export interface OrderCustomer {
  id: string;
  name: string;
}

export interface FoodOrderItem {
  item: FoodItem;
  amount: number;
  price: number;
}

export interface Delivery {
  estimateTime: Date;
}

export interface FoodOrderShallow {
  id: string;
  no: number;
  customer: OrderCustomer;
  estimatedReadyAt: Date;
  readyForAcceptedAt: Date;
  totalPrice: number;
  deliveryAssignmentDriverStatus?: string;
  finalPrice: number;
  status: OrderStatuses;
  numberOfItems: number;
  readyRemainingTime?: number;
  acceptRemainingTime?: number;
  deliveryRemainingTime?: number;
  isPickup: boolean;
}

export interface FoodOrderHistory {
  id: string;
  status: OrderStatuses;
  customerName: string;
  updatedById: number;
  createdAt: Date;
  orderNo: number;
  orderPrice: number;
  orderNumberOfItems: number;
  payout?: any;
}

export interface OrderReview {
  orderId: string;
  id: string;
  customerName: string;
  customerId: string;
  customerProfileImage: string;
  content?: string;
  replyContent?: string;
  rating: number;
  orderTotal: string;
  orderPlacingDate: Date;
  totalLike: number;
  totalDislike: number;
  userTotalOrderFinished: number;
}

export class RestaurantNotification {
  id: string;
  restaurantId: string;
  title: string;
  message: string;
  type: string;
  data: any;
  status: NotificationStatus;
  createdAt: Date;
}

export enum NotificationStatus {
  READ = "READ",
  UNREAD = "UNREAD",
}
